import React, { useState, useEffect } from "react";
import Tesseract from "tesseract.js";
import Header from "./Header";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const TexttoSpeech = () => {
  const [text, setText] = useState("");
  const [selectedVoice, setSelectedVoice] = useState(null);
  const [utterance, setUtterance] = useState(null); // Track the utterance
  const [isSpeaking, setIsSpeaking] = useState(false); // Track speaking state
  const [loading, setLoading] = useState(false);

  const location = useLocation();

  useEffect(() => {
    const handleVoicesChanged = () => {
      const availableVoices = speechSynthesis.getVoices();
      const bangladeshiVoice = availableVoices.find(
        (voice) => voice.lang === "bn-BD"
      );

      setSelectedVoice(bangladeshiVoice); // Set Bangladeshi voice by default
    };

    speechSynthesis.onvoiceschanged = handleVoicesChanged;
    handleVoicesChanged(); // Initial load

    return () => {
      speechSynthesis.onvoiceschanged = null; // Clean up listener
    };
  }, []);

  // Stop speaking when text changes
  useEffect(() => {
    if (isSpeaking) {
      stopSpeaking();
    }
  }, [text]); // Dependency on text

  useEffect(() => {
    // Stop speaking if the path is not "/ttos"
    const currentPath = location.pathname;

    console.log("path", location.pathname);
    if (location.pathname !== "/ttos" && isSpeaking) {
      console.log("Stopping speech because path changed:", currentPath);
      stopSpeaking();
      setText("");
    }
  }, [location.pathname, isSpeaking]);

  const handleTextChange = (event) => {
    setText(event.target.value);
  };

  const toggleSpeak = () => {
    if (isSpeaking) {
      stopSpeaking();
    } else {
      speak();
    }
  };

  const speak = () => {
    if (text.trim() === "") {
      toast.warn("Please enter some text or upload an image!");
      return;
    }

    const newUtterance = new SpeechSynthesisUtterance(text);
    newUtterance.voice = selectedVoice;

    newUtterance.onend = () => {
      console.log("Speech has finished.");
      setIsSpeaking(false); // Update speaking state
      setUtterance(null); // Clear utterance when finished
    };

    newUtterance.onerror = (event) => {
      console.error("Speech synthesis error:", event.error);
    };

    speechSynthesis.speak(newUtterance);
    setUtterance(newUtterance); // Track the current utterance
    setIsSpeaking(true); // Update speaking state
  };

  const stopSpeaking = () => {
    if (utterance) {
      speechSynthesis.cancel(); // Stop the speech synthesis
      setIsSpeaking(false); // Update speaking state
      setUtterance(null); // Clear the utterance
    }
  };

  const handleImageUpload = (event) => {
    setLoading(true);
    const file = event.target.files[0];
    if (file) {
      extractTextFromImage(file);
    }
  };

  const extractTextFromImage = (file) => {
    Tesseract.recognize(file, "eng", {
      logger: (m) => console.log(m), // Optional: log progress
    })
      .then(({ data: { text } }) => {
        setText(text);
        setLoading(false);
        console.log("Extracted text:", text);
      })
      .catch((err) => {
        console.error("Error extracting text:", err);
        setLoading(false); // Ensure loading state is reset on error
      });
  };

  return (
    <div className="pb-4">
      <Header />

      <h1 className="text-center text-white">Text to Speech</h1>
      {/* <div className="text-center text-light fw-semibold">
        Convert text to the most natural sounding voice online for free
      </div> */}

      {/* Desktop Version */}
      <div className="d-none d-lg-block d-md-block mt-4 border border-white rounded-3 p-3 w-50 m-auto">
        <div>
          <div className="position-relative">
            <textarea
              value={text}
              onChange={handleTextChange}
              rows="10"
              cols="30"
              placeholder="Enter text here..."
              className="textarea text-white px-1 w-100 rounded-3 bg-transparent"
              style={{ outline: "none" }}
            />
            {loading && (
              <div className="position-absolute start-50 top-50 translate-middle">
                <span className="loader"></span>
              </div>
            )}
          </div>
          <br />

          <input
            type="file"
            className="form-control w-50"
            accept="image/*"
            onChange={handleImageUpload}
          />
          <br />

          <div className="d-flex justify-content-end">
            <button
              className={`btn ${isSpeaking ? "btn-danger" : "btn-info"}`}
              onClick={toggleSpeak}
            >
              {isSpeaking ? "Stop" : "Generate Speech"}
              <span
                className={`ms-2 bi ${isSpeaking ? "bi-stop" : "bi-megaphone"}`}
              ></span>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Version */}
      <div className="d-sm-block d-lg-none d-md-none mt-4 border border-white rounded-3 p-3 w-100 m-auto">
        <div>
          <textarea
            value={text}
            onChange={handleTextChange}
            rows="20"
            cols="30"
            placeholder="Enter text here..."
            className="textarea w-100 rounded-3 text-white bg-transparent"
            style={{ outline: "none" }}
          />
          {loading && (
            <div className="position-absolute top-50 start-50 translate-middle">
              <span className="loader"></span>
            </div>
          )}
        </div>
        <br />

        <input
          type="file"
          className="form-control w-100"
          accept="image/*"
          onChange={handleImageUpload}
        />
        <br />

        <div className="d-flex justify-content-end">
          <button
            className={`btn ${isSpeaking ? "btn-danger" : "btn-info"}`}
            onClick={toggleSpeak}
          >
            {isSpeaking ? "Stop" : "Generate Speech"}
            <span
              className={`ms-2 bi ${isSpeaking ? "bi-stop" : "bi-megaphone"}`}
            ></span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default TexttoSpeech;
